<template>
  <span :class="elementClass">
    <slot></slot>
  </span>
</template>

<script>
import { appbarTitleClass } from "../prefix";
export default {
  computed: {
    elementClass() {
      return appbarTitleClass + " font-title";
    },
  },
};
</script>
